import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

class TransporteurSelect extends React.Component {
    render() {
        const { value, onChange, transporteurs, all, excluded, isRequired, error, disabled } = this.props;

        return (
            <TextField
                select
                name="transporteurId"
                label="Transporteur"
                value={value}
                onChange={onChange}
                required={isRequired}
                error={error !== undefined}
                fullWidth
                disabled={disabled}
            >

                {all === true ? <MenuItem key={0} value={0}><em>Tous</em></MenuItem> : null}

                {transporteurs.map(transporteur => (

                    (excluded === null || excluded !== transporteur.id) &&

                    (<MenuItem key={transporteur.id} value={transporteur.id}>
                        {transporteur.nom}
                        </MenuItem>)
                ))}

            </TextField>
        );
    }
}

TransporteurSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    all: PropTypes.bool.isRequired,
    excluded: PropTypes.number,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,

    transporteurs: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired

};

export default TransporteurSelect;